import React, { Component } from 'react';

import CTAButton from './ctaButton';
import RoundedContainer from './roundedContainer';
import DividerLine from './dividerLine';

import wpStyles from '../../wordpressStyles';

function SuperScript(props) {
    const styles = {
        position: 'relative',
        top: '-0.5em'
    };
    return (
        <span className={props.className} style={styles}>
            {props.children}
        </span>
    );
}

function CustomButton(props) {
    if (props.hideButton || !props.buttonText) return '';
    return (
        <div className="flex-grow-0 pt-4 lg:pt-0 flex items-center min-w-xs justify-center">
            <CTAButton
                onButtonClick={props.onButtonClick}
                text={
                    props.buttonDisabled
                        ? props.buttonDisabledText
                        : props.buttonToggled
                        ? props.buttonToggleText
                        : props.buttonText
                }
                toggled={props.buttonToggled}
                busy={props.busy}
                disabled={props.buttonDisabled}
            />
        </div>
    );
}


class ScheduleListItem extends React.Component {
    render() {
        return (
            <RoundedContainer className="my-1">
                {/* {this.props.registered && (
                <RoundedContainer  className="absolute registered-pill items-center justify-center text-white text-xs bg-red-500"><p>Registered</p></RoundedContainer>
                )} */}
                <div className="flex-1 flex-grow">
                    <h3 className="text-red-500 font-bold text-lg lg:text-2xl" style={wpStyles.textColor1}>{this.props.titleText}</h3>
                    <p className="text-md lg:text-xl" style={wpStyles.textColor2}>{this.props.descriptionText}</p>
                </div>
                {!this.props.hideLabel && !this.props.hideButton && <DividerLine />}
                {!this.props.hideLabel && (
                    <div className="flex-grow-0 text-red-500 py-6 lg:py-0 flex items-center justify-center min-w-sm" style={wpStyles.textColor1}>
                        <span className="font-bold text-2xl lg:text-4xl">{this.props.timeText}</span>
                        <SuperScript className="text-sm lg:text-lg">{this.props.timezoneText}</SuperScript>
                    </div>
                )}
                <CustomButton {...this.props} />
            </RoundedContainer>
        );
    }
}

ScheduleListItem.defaultProps = {
    titleText: '',
    descriptionText: '',
    buttonText: '',
    timeText: '',
    timezoneText: '',
    busy: false,
    hideButton: false,
    hideLabel: false,
    registered: false,
    onButtonClick: () => {}
};

export default ScheduleListItem;
